import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"

export const Section = styled(SectionWrapper)`
  position: relative;
`

export const BackgroundImage = styled(CustomBgImage)`
  /* width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  img {
    object-fit: cover !important;
    width: 100%;
    height: 680px;
    border-radius: 20px;
  } */

  height: 680px;
  border-radius: 20px;

  /* ${({ theme }) => theme.breakpoints.down("md")} {
    padding-left: 1rem;
    padding-right: 1rem;
  } */
`

export const Wrapper = styled(Container)`
  position: relative;
  height: 680px;
`

export const ContentContainer = styled.div`
  position: relative;
  padding: ${({ theme }) => theme.typography.pxToRem(80)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 3rem 1.5rem;
  }
`

export const Logo = styled(CustomImage)`
  width: 164.043px;
  height: 40px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(80)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 147px;
    height: 36px;
  }
`

export const Description = styled(Typography)`
  max-width: 670px;
  font-size: ${({ theme }) => theme.typography.pxToRem(26)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(38)};
  color: ${({ theme }) => theme.palette.primary.light};
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(40)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    line-height: ${({ theme }) => theme.typography.pxToRem(32)};
    font-weight: 500;
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(28)};
  }
`
